import React from 'react';
import useNotification from '../../../../../core/hooks/use_notification';
import { useDispatch, useSelector } from 'react-redux';
import { getDocumentsState } from '../../../../../features/food_partner/get_documents';
import { deleteDocumentAction, deleteDocumentState } from '../../../../../features/food_partner/delete_document';
import { deleteDocumentNotificationData } from '../../../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../../../core/enums/common/api';
import { IconButton, Link, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { DeleteButton } from '../../../../common/button';
import DownloadIcon from '@mui/icons-material/Download';

const DocumentsList = ({ foodPartnerId, refreshList }) => {
    const { showNotification } = useNotification();
    const dispatch = useDispatch();

    const getDocuments = useSelector(getDocumentsState);
    const deleteDocument = useSelector(deleteDocumentState);

    const onDeleteDocument = (documentId) => {
        dispatch(deleteDocumentAction({ foodPartnerId, documentId }))
            .then(response => {
                showNotification(deleteDocumentNotificationData(response));
                response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED && refreshList();
            });
    }

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell>Nazwa</TableCell>
                        <TableCell align="center" sx={ { width: 120 } }></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        getDocuments?.data?.map(document => (
                            <TableRow key={ document?.id } hover>
                                <TableCell sx={ { fontWeight: 500 } }>{ document?.name }</TableCell>
                                <TableCell align="center">
                                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={ 1 }>
                                        <Tooltip title="Pobierz dokument">
                                            <Link href={ document?.url } target="_blank" rel="noreferrer">
                                                <IconButton size="small">
                                                    <DownloadIcon fontSize="small"/>
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                        <DeleteButton
                                            onDeleteClick={ () => onDeleteDocument(document?.id) }
                                            isLoading={ deleteDocument?.loading }
                                        />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))
                    }
                    { (!getDocuments?.data || getDocuments?.data?.length === 0) && (
                        <TableRow>
                            <TableCell colSpan={ 2 } align="center" sx={ { py: 4, color: 'text.secondary' } }>
                                Brak załączonych dokumentów.
                            </TableCell>
                        </TableRow>
                    ) }
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default DocumentsList;